const MathHelper = require('./math-helper');

// 计算瞳距
export function calculatePD( left_eye_pos, right_eye_pos ) {
    return MathHelper.euclideanDistance( left_eye_pos, right_eye_pos );
}

// 计算中心比例
export function calcCenterRatio( eye_left_ratio, eye_right_ratio ) {
    return {
        x: (eye_right_ratio.x + eye_left_ratio.x) /2,
        y: (eye_right_ratio.y + eye_left_ratio.y) /2
    }
}

// 计算像素位置
export function calcPixelPosition( img_size, xy_ratio) {
    return {
        x: img_size.w * xy_ratio.x / 100,
        y: img_size.h * xy_ratio.y / 100
    }
}
// 调整像素位置
export function adjustPosition( origin_pos , shift ) {
    return {
        x: origin_pos.x + shift.x ,
        y: origin_pos.y + shift.y 
    }
}

// 计算当前头部偏航角所对应的 X Y 轴偏移像素
export function poseYawTranslate( yaw_angle , depth ) {
    return MathHelper.tanDistanceByDegree( - yaw_angle , depth );
}

export function calcGlassJointPosition(
    frame_center_position , glass_actual_size , origin_joint_ratio
) {
    var joint_position =  calcPixelPosition( glass_actual_size , origin_joint_ratio );
    return {
        x : frame_center_position.x + joint_position.x - glass_actual_size.w *.5,
        y : frame_center_position.y + joint_position.y - glass_actual_size.h *.5
    }
}

export function calcTempleShift( temple_actual_size , temple_joint ) {
    return {
        x : 0 ,
        y : - ( temple_actual_size.h * ( temple_joint.left.y / 100 ) )
    }
}

